export default "/_next/static/images/advertIdeas-0b68688daa4af067d3302120418f8512.png";